import '../styles/components/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 soMeet — Wszystkie prawa zastrzeżone</p>
      <div className="footer-links">
        <a href="/aboutus">O nas</a>
        <a href="/contact">Kontakt</a>
        <a href="/privacy-policy">Polityka Prywatności</a>
        <a href="/terms">Warunki korzystania</a>
      </div>
    </footer>
  );
}

export default Footer;
